export default function HeroSection() {
  return (
    <section className="relative min-h-[620px] md:min-h-[700px] flex items-center overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20modern%20minimalist%20composition%20with%20soft%20warm%20cream%20and%20beige%20background%2C%20delicate%20overlapping%20geometric%20circles%20and%20flowing%20organic%20shapes%20in%20muted%20sand%20tones%2C%20subtle%20sage%20green%20and%20warm%20terracotta%20accents%2C%20contemporary%20gallery%20wall%20aesthetic%20with%20abundant%20negative%20space%2C%20sophisticated%20matte%20textures%20with%20gentle%20gradient%20transitions&width=1800&height=1000&seq=hero-bg-v2-main&orientation=landscape"
          alt="AllChinaBuy Spreadsheet background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/12 to-background-50"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 py-20 md:py-0">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-12 lg:gap-16">
          <div className="flex-1 text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 bg-accent-100/80 text-accent-800 rounded-full text-xs font-medium mb-6">
              <i className="ri-sparkling-line"></i>
              <span>Updated Weekly — 1000+ Verified Finds</span>
            </div>

            <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 leading-tight mb-6">
              Best AllChinaBuy Spreadsheet 2026
            </h1>

            <p className="text-base md:text-lg text-background-100/90 max-w-xl mx-auto lg:mx-0 mb-8 leading-relaxed">
              Discover the latest sneakers, clothing, bags, watches, and accessories from trusted sellers with our
              constantly updated <strong>AllChinaBuy Spreadsheet</strong>. Save time, save money, and shop smarter.
            </p>

            <div className="flex flex-col sm:flex-row items-center gap-4 justify-center lg:justify-start">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 text-background-50 rounded-full text-base font-semibold hover:bg-primary-600 transition-all hover:scale-[1.02] whitespace-nowrap cursor-pointer w-full sm:w-auto justify-center"
              >
                Buy It Now
                <i className="ri-arrow-right-line"></i>
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-2 px-8 py-3.5 bg-background-50/20 backdrop-blur-sm text-background-50 border border-background-50/30 rounded-full text-base font-semibold hover:bg-background-50/30 transition-all whitespace-nowrap cursor-pointer w-full sm:w-auto justify-center"
              >
                Browse Spreadsheet
                <i className="ri-external-link-line"></i>
              </a>
            </div>

            <div className="flex flex-wrap items-center gap-6 justify-center lg:justify-start mt-10">
              {['Updated Daily', 'Verified Sellers', 'QC Checked', 'Beginner Friendly'].map((badge) => (
                <div key={badge} className="flex items-center gap-2 text-sm text-background-100/80">
                  <i className="ri-checkbox-circle-fill text-accent-400 text-base"></i>
                  <span className="whitespace-nowrap">{badge}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="flex-1 hidden lg:flex items-center justify-center">
            <div className="relative w-full max-w-lg">
              <div className="grid grid-cols-2 gap-3">
                {[
                  'https://readdy.ai/api/search-image?query=Modern%20white%20sneaker%20pair%20on%20warm%20cream%20marble%20surface%2C%20soft%20natural%20window%20light%20from%20left%20side%2C%20minimalist%20product%20photography%2C%20clean%20editorial%20fashion%20shot%2C%20warm%20beige%20and%20sand%20neutral%20tones%2C%20delicate%20gentle%20shadows%20with%20refined%20aesthetic&width=400&height=400&seq=hero-g1-v2-001&orientation=squarish',
                  'https://readdy.ai/api/search-image?query=Elegant%20designer%20leather%20handbag%20on%20warm%20cream%20textured%20backdrop%2C%20soft%20diffused%20studio%20lighting%2C%20luxury%20accessories%20product%20photography%2C%20warm%20caramel%20and%20cream%20tones%2C%20editorial%20refined%20presentation%20with%20subtle%20natural%20shadowing&width=400&height=400&seq=hero-g2-v2-002&orientation=squarish',
                  'https://readdy.ai/api/search-image?query=Premium%20casual%20hoodie%20sweatshirt%20flat%20lay%20on%20warm%20cream%20linen%20surface%2C%20soft%20daylight%20illumination%2C%20minimalist%20fashion%20product%20photography%2C%20warm%20oatmeal%20and%20beige%20neutral%20palette%2C%20clean%20contemporary%20editorial%20shot%20with%20delicate%20fabric%20details&width=400&height=400&seq=hero-g3-v2-003&orientation=squarish',
                  'https://readdy.ai/api/search-image?query=Fashion%20accessories%20watch%20and%20minimalist%20jewelry%20on%20warm%20cream%20ceramic%20surface%2C%20soft%20natural%20ambient%20light%2C%20clean%20luxury%20product%20photography%2C%20warm%20neutral%20sand%20and%20cream%20tones%2C%20elegant%20editorial%20lifestyle%20arrangement%20with%20refined%20composition&width=400&height=400&seq=hero-g4-v2-004&orientation=squarish',
                ].map((src, i) => (
                  <div key={i} className="aspect-square rounded-xl overflow-hidden bg-background-100">
                    <img
                      src={src}
                      alt={`AllChinaBuy product ${i + 1}`}
                      className="w-full h-full object-cover"
                      loading="lazy"
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}